import Vue from 'vue';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

Bugsnag.start({
  apiKey: '6f37676a89c42256205b8d312fdea234',
  plugins: [new BugsnagPluginVue()],
  appVersion: process.env.VERSION,
  releaseStage: process.env.RELEASE,
  notifyReleaseStages: ['production'],
});

Bugsnag.getPlugin('vue')
  .installVueErrorHandler(Vue);
